export const splitStringByCapitalLetter = (source) => {
  if (!source) return ''
  return source.split(/(?=[A-Z])/).join(' ');
}

export const capitalizeFirstLetter = (source) => {
  if (!source) return ''
  return source.charAt(0).toUpperCase() + source.slice(1);
}
